// @flow
import React from "react"
import { compose, type HOC, withStateHandlers } from "recompose"
import withConnect from "hoc/withConnect"
import { chooseProductGroups } from "data/app/actions"
import { selectProductGroups } from "data/app/selectors"
import { clear } from "data/search/actions"
import type { GooglePlace } from "data/locations/types"
import PlaceDetails from "./PlaceDetails"
import { AffiliateSelectWrap, PlaceDetailsWrap } from "./styled"
import PlaceSearch from "./PlaceSearch"

/**
 * Renders a Google Autocomplete input & the returned Place from the Google Place Details API
 */
const AffiliateSelector = ({ handleSelect, handleChange, selected, address, placeId, selectAffiliate, affiliate, setAffiliateEmail }) => (
  <React.Fragment>
    <AffiliateSelectWrap>
      <PlaceSearch
        handleSelect={handleSelect}
        handleChange={handleChange}
        value={address}
        debounce={1000}
        types={["establishment"]}
        placeholder={"Start searching to find your store..."}
      />
    </AffiliateSelectWrap>
    <PlaceDetailsWrap>
      {affiliate && <PlaceDetails
       affiliate={affiliate}
       setAffiliateEmail={setAffiliateEmail} />}
    </PlaceDetailsWrap>
  </React.Fragment>
)

const mapStateToProps = state => ({
  productGroups: selectProductGroups(state),
})

const mapDispatchToProps = {
  clear,
  chooseProductGroups,
}

type Outter = {
  selectAffiliate: (placeId: string) => void,
  affiliate: ?GooglePlace,
  setAffiliateEmail: (affiliateEmail: string) => void,
}

const enhancer: HOC<*, Outter> = compose(
  withConnect(mapStateToProps, mapDispatchToProps),
  withStateHandlers(
    {
      address: "",
      placeId: "",
      selected: false,
    },
    {
      handleSelect: (state, props) => (address, placeId) => {
        props.selectAffiliate(placeId)
        return {
          selected: true,
          address: address,
          placeId: placeId
        }
      },
      handleChange: props => (address) => {
       return {
         address: address
       }
      }
    },
  ),
)

export default enhancer(AffiliateSelector)



// WEBPACK FOOTER //
// ./src/pages/AffiliateRegistration/AffiliateSelector/index.js